import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import NumberField from 'components/NumberField/NumberField';
import {
  EQUITY_SHAREHOLDING,
  FINANCIAL_CONTROL,
} from 'constants/formFields';
import { NUMBER_FORMATS } from 'constants/interfaces';

import type { IFinancialFields } from '../interfaces/IFinancialFields';

function FinancialFields({
  control,
  placeholder,
}: IFinancialFields) {
  const { t } = useTranslation();

  return (
    <>
      <Controller
        control={control}
        name={EQUITY_SHAREHOLDING}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <NumberField
            name={name}
            value={value}
            label={t('customers.fields.equityShareholding')}
            error={error?.message}
            onChange={(values) => onChange(values.value)}
            type={NUMBER_FORMATS.percent}
            placeholder={placeholder || t('customers.fields.equityShareholding')}
            allowNegative={false}
            max={100}
          />
        )}
      />
      <Controller
        control={control}
        name={FINANCIAL_CONTROL}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <NumberField
            name={name}
            value={value}
            label={t('customers.fields.financialControl')}
            error={error?.message}
            onChange={(values) => onChange(values.value)}
            type={NUMBER_FORMATS.percent}
            placeholder={placeholder || t('customers.fields.financialControl')}
            allowNegative={false}
            max={100}
          />
        )}
      />
    </>
  );
}

export default FinancialFields;
